export default __webpack_public_path__ + "static/media/frame-card-overseer.3b17e1af.png";